document.addEventListener('DOMContentLoaded', function() {
    let dataGallery = document.querySelector('[data-gallery]');
    let url = dataGallery.dataset.url;
    let sectionId = dataGallery.dataset.section;
    let urlFetch = url + '?section_id=' + sectionId;

    let swiper, swiper2; // глобально, щоб можна було знищувати

    addingFilter();

    function addingFilter() {
        dataGallery.querySelectorAll('[data-year]').forEach(function(item) {
            if (!item.dataset.bound) { // ✅ перевірка, чи вже є обробник
                item.dataset.bound = "true"; // ставимо мітку
                item.addEventListener('click', function(e) {
                    if (item.classList.contains('active')) return;

                    dataGallery.classList.add('loading');
                    let activeEl = dataGallery.querySelector('.active[data-year]');
                    if (activeEl) activeEl.classList.remove('active');
                    item.classList.add('active');

                    let clickYear = item.dataset.year;
                    let forUrlFetch = '';

                    if (urlFetch.includes('&year_code=')) {
                        let arrurlFetch = urlFetch.split('&year_code=');
                        arrurlFetch[0] += '&view=detail' + Math.floor((Math.random() * 1000) + 1);
                        arrurlFetch[1] = clickYear;
                        forUrlFetch = arrurlFetch.join('&year_code=');
                    } else {
                        forUrlFetch = urlFetch + '&view=detail' + Math.floor((Math.random() * 1000) + 1) + '&year_code=' + clickYear;
                    }


                    fetch(forUrlFetch)
                        .then(response => response.text())
                        .then(responseText => {
                            const doc = new DOMParser().parseFromString(responseText, 'text/html');
                            let dataGalleryFetch = doc.querySelector('[data-gallery]');

                            if (dataGalleryFetch) {
                                dataGallery.innerHTML = dataGalleryFetch.innerHTML;
                                dataGallery.dataset.gallery = dataGalleryFetch.dataset.gallery;

                                // 🔄 перевстановлюємо обробники
                                addingFilter();

                                // ✅ lazy-load без перезавантаження вже підвантажених
                                document.querySelectorAll("img[data-src], [data-srcset]").forEach(img => {
                                    if (img.getAttribute("data-src")) {
                                        img.src = img.dataset.src;
                                    }
                                    if (img.getAttribute("data-srcset")) {
                                        img.srcset = img.dataset.srcset;
                                    }
                                    img.onload = () => {
                                        img.removeAttribute("data-src");
                                        img.removeAttribute("data-srcset");
                                    };
                                });

                                // ✅ знищуємо старі Swiper перед ініціалізацією
                                if (swiper) swiper.destroy(true, true);
                                if (swiper2) swiper2.destroy(true, true);

                                initSwiper(); // запускаємо новий

                                // ✅ zoom ініціалізуємо без дублювання
                                initZoom(".img-zoom-container");

                                // ✅ міняємо URL без повного рефрешу
                                let newLink = forUrlFetch.split('?')[0] + '?' + forUrlFetch.split('?')[1].split('&')[2];
                                window.history.replaceState({}, '', newLink);

                                dataGallery.classList.remove('loading');
                            }
                        });
                });
            }
        });
    }

    // === Swiper ===
    function initSwiper() {
        var count = $(".collection_gallery-count");
        var title = $(".collection_gallery-title");
        var tag = $(".category-tag");
        var buttonLink = $(".shopnow_button-link");

        var thumbs = new Swiper(".thumbs_swiper", {
            spaceBetween: 8,
            slidesPerView: "auto",
            freeMode: true,
            watchSlidesProgress: true,
            scrollbar: { el: ".swiper-scrollbar", hide: true },
            direction: "vertical",
            mousewheel: true
        });

        swiper = thumbs;

        swiper2 = new Swiper(".preview_swiper", {
            spaceBetween: 32,
            slidesPerView: 1.3,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            thumbs: { swiper: thumbs },
            breakpoints: {
                575: { spaceBetween: 32, slidesPerView: 2.3, slidesOffsetBefore: 16, slidesOffsetAfter: 16 },
                1025: { spaceBetween: 0, effect: "fade", slidesPerView: 1, slidesOffsetBefore: 0, slidesOffsetAfter: 0 }
            },
            on: {
                init: function() { updateSlideInfo(this, count, title, tag, buttonLink); },
                slideChange: function() { updateSlideInfo(this, count, title, tag, buttonLink); }
            }
        });
    }

    function updateSlideInfo(swiper, count, title, tag, buttonLink) {
        var indexCurrentSlide = swiper.realIndex;
        var currentSlide = swiper.slides[indexCurrentSlide];
        var tagV = $(currentSlide).data("product-tag");

        count.html(`${indexCurrentSlide + 1} — ${swiper.slides.length}`);
        title.html($(currentSlide).data("product-name"));
        if (tagV) {
            tag.html(tagV).css("display", "flex");
        } else {
            tag.html("").css("display", "none");
        }
        buttonLink.attr("href", $(currentSlide).data("product-url"));
    }

    // === Zoom ===
    function initZoom(containerClass) {
        var allContainers = document.querySelectorAll(containerClass);
        allContainers.forEach(elem => {
            let img = elem.querySelector("img");
            if (!img) return;

            let lens = elem.querySelector(".img-zoom-lens");
            let result = elem.querySelector(".img-zoom-result");

            if (!lens) {
                lens = document.createElement("DIV");
                lens.setAttribute("class", "img-zoom-lens");
                img.parentElement.insertBefore(lens, img);
            }
            if (!result) {
                result = document.createElement("DIV");
                result.setAttribute("class", "img-zoom-result");
                img.parentElement.insertBefore(result, img);
            }

            let cx = elem.offsetWidth / lens.offsetWidth;
            let cy = elem.offsetHeight / lens.offsetHeight;

            result.style.backgroundImage = `url('${img.src}')`;
            result.style.backgroundSize = `${img.width * cx}px ${img.height * cy}px`;

            function moveLens(e) {
                e.preventDefault();
                let pos = getCursorPos(e, img);
                let x = pos.x - lens.offsetWidth / 2;
                let y = pos.y - lens.offsetHeight / 2;

                if (x > img.width - lens.offsetWidth) x = img.width - lens.offsetWidth;
                if (x < 0) x = 0;
                if (y > img.height - lens.offsetHeight) y = img.height - lens.offsetHeight;
                if (y < 0) y = 0;

                lens.style.left = x + "px";
                lens.style.top = y + "px";
                result.style.backgroundPosition = `-${x * cx}px -${y * cy}px`;
            }

            lens.onmousemove = moveLens;
            elem.onmousemove = moveLens;
        });
    }

    function getCursorPos(e, img) {
        var a = img.getBoundingClientRect();
        var x = e.pageX - a.left - window.pageXOffset;
        var y = e.pageY - a.top - window.pageYOffset;
        return { x, y };
    }

    // on resize
    let resizeTimeout;
    window.addEventListener("resize", function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => initZoom(".img-zoom-container"), 600);
    });
});
